/* RAVIN / THE FIT LAB / CHAPTER 03 / MODEL-FREE RESULTS / 18 OCT 2026
   Presentation only: preserve source result values and all original Apply
   Size / alternative / diagnostic handlers from ravin-fit-lab.js.
   Do not touch size tables, inventory logic, inputs, or Marketing Studio. */
(()=>{
  if(window.__RavinFitLabResultCh3_2026)return;
  window.__RavinFitLabResultCh3_2026=true;
  const phrases={
    en:{
      overline:'RAVIN / FIT LAB · 03',
      label:'WE FOUND YOUR FIT',
      why:'WHY THIS SIZE?',
      preference:'YOUR PREFERRED FIT',
      noDetail:'The fitting service did not provide a detailed explanation.',
      disclaimer:'Your fit preference helps guide the recommendation. It does not change the garment’s original cut.',
      accessible:'RAVIN size recommendation'
    },
    ar:{
      overline:'ريفين / مختبر المقاسات · ٠٣',
      label:'لقينا المقاس المناسب ليك',
      why:'ليه المقاس ده؟',
      preference:'القصة اللي اخترتها',
      noDetail:'خدمة المقاسات ماقدمتش شرح تفصيلي للنتيجة.',
      disclaimer:'اختيارك للقصة بيساعدنا نرشّح المقاس، لكنه مش بيغيّر قصة القطعة الأصلية.',
      accessible:'ترشيح المقاس من ريفين'
    }
  };
  const prefLabels={
    en:{Slim:'Slim / Fitted','True to Size':'True to Size',Relaxed:'Relaxed'},
    ar:{Slim:'ضيق / على الجسم','True to Size':'مظبوط',Relaxed:'واسع'}
  };
  const isResult=ov=>ov?.dataset.open==='true'&&ov?.dataset.rvFlView==='fit'&&ov?.dataset.rvFlChapter==='3';
  const make=(tag,cls,text)=>{
    const el=document.createElement(tag);
    el.className=cls;
    if(text!=null)el.textContent=text;
    return el;
  };
  function setupDock(ov,button){
    const dock=ov.querySelector('[data-rv-fl-mobile-continue]');
    ov.dataset.rvFlResult3Action=button?'true':'false';
    if(!dock)return;
    if(!button)return;
    const label=button.textContent.replace(/\s+/g,' ').trim();
    dock.textContent=label;
    dock.setAttribute('aria-label',label);
    dock.disabled=Boolean(button.disabled);
    if(dock.dataset.rvFlResult3Handler==='true')return;
    dock.dataset.rvFlResult3Handler='true';
    dock.addEventListener('click',event=>{
      if(!isResult(ov))return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const original=ov.querySelector('.rv-fl-guided-result [data-rv-fl-apply].rv-fl-cta');
      if(original&&!original.disabled)original.click();
    },true);
  }
  function enhance(ov){
    if(!isResult(ov))return;
    const layout=ov.querySelector('.rv-fl-guided-layout--result');
    const panel=layout?.querySelector('.rv-fl-guided-result');
    if(!layout||!panel)return;
    if(panel.dataset.rvFlResult3Ready==='true')return;
    const isAr=ov.dir==='rtl';
    const lang=isAr?'ar':'en',t=phrases[lang];
    const character=layout.querySelector('.rv-fl-guided-character');
    const rawPref=character?.dataset.fitChoice||'True to Size';
    const fitPref=prefLabels[lang][rawPref]||prefLabels[lang]['True to Size'];
    // No person/model image, character, illustrated shirt, or face remains in Chapter 03.
    character?.remove();
    layout.classList.add('rv-fl-result3-layout');
    panel.classList.add('rv-fl-result3-panel');
    const heading=panel.querySelector('h2');
    heading?.classList.add('rv-fl-result3-heading');
    const chapter=panel.querySelector('.rv-fl-guided-chapter');
    if(chapter)chapter.textContent=t.overline;
    const result=panel.querySelector('.rv-fl-result');
    const primary=result?.querySelector('.rv-fl-cta[data-rv-fl-apply]');
    if(result){
      result.classList.add('rv-fl-result3-content');
      const labels=[...result.querySelectorAll('.rv-fl-result__confidence')];
      const recommendation=labels[0];
      const confidence=labels[1];
      const size=result.querySelector('.rv-fl-result__size');
      const summary=result.querySelector('.rv-fl-result__summary');
      const alternative=result.querySelector('.rv-fl-result__mini');
      const alternateButton=result.querySelector('.rv-fl-secondary[data-rv-fl-apply]');
      const diagnostic=result.querySelector('[data-rv-fl-diagnostic]');
      if(size&&recommendation){
        const hero=make('section','rv-fl-result3-hero');
        hero.setAttribute('aria-label',t.accessible);
        const top=make('div','rv-fl-result3-topline');
        top.append(make('span','rv-fl-result3-series',t.overline));
        top.append(make('span','rv-fl-result3-arrival',t.label));
        hero.append(top);
        const number=make('div','rv-fl-result3-number');
        recommendation.classList.add('rv-fl-result3-recommendation-label');
        size.classList.add('rv-fl-result3-primary-size');
        number.append(recommendation,size);
        hero.append(number);
        const meta=make('div','rv-fl-result3-meta');
        const pref=make('div','rv-fl-result3-preference');
        pref.append(make('span','rv-fl-result3-meta-label',t.preference));
        pref.append(make('strong','rv-fl-result3-meta-value',fitPref));
        meta.append(pref);
        if(confidence&&!/[:：]\s*[—–-]\s*$/.test(confidence.textContent.trim())){
          confidence.classList.add('rv-fl-result3-service-confidence');
          meta.append(confidence);
        }else confidence?.remove();
        hero.append(meta);
        result.prepend(hero);
      }
      if(summary){
        const why=make('section','rv-fl-result3-why');
        why.append(make('h3','rv-fl-result3-smallheading',t.why));
        if(summary.textContent.trim()==='OUR FIT NOTE'||summary.textContent.trim()==='ملاحظات عن المقاس'){
          summary.textContent=t.noDetail;
        }
        why.append(summary);
        result.append(why);
      }
      if(alternative){
        alternative.classList.add('rv-fl-result3-alternative');
        result.append(alternative);
      }
      const actions=make('div','rv-fl-result3-actions');
      if(primary)actions.append(primary);
      if(alternateButton)actions.append(alternateButton);
      if(diagnostic)actions.append(diagnostic);
      if(actions.childElementCount)result.append(actions);
      result.append(make('p','rv-fl-result3-disclaimer',t.disclaimer));
    }else{
      panel.querySelector('.rv-fl-result__stub')?.classList.add('rv-fl-result3-no-match');
    }
    const extra=[...panel.querySelectorAll(':scope > [data-rv-fl-return],:scope > [data-rv-fl-tab]')];
    if(extra.length){
      const navigation=make('div','rv-fl-result3-navigation');
      extra.forEach(x=>navigation.append(x));
      panel.append(navigation);
    }
    setupDock(ov,primary);
    panel.dataset.rvFlResult3Ready='true';
    ov.dataset.rvFlResult3Ready='true';
  }
  let pending=false;
  function sync(){
    pending=false;
    const ov=document.querySelector('.rv-fl-overlay[data-open="true"]');
    if(isResult(ov))enhance(ov);
  }
  function schedule(){
    if(pending)return;
    pending=true;
    queueMicrotask(sync);
  }
  function start(){
    if(!document.body)return;
    new MutationObserver(schedule).observe(document.body,{
      subtree:true,childList:true,attributes:true,
      attributeFilter:['data-open','data-rv-fl-view','data-rv-fl-chapter']
    });
    schedule();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();